export default __webpack_public_path__ + "images/icons/arrow-down-c9a507fcaa8c67a0446ce057a9e5500b.svg";